import classNames from "classnames";

export const className = (...params: any) => ({ className: classNames(params) });